export function HeaderAccountMyaccountSVG({ width, height, viewBox }) {
	return (
		<svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.5667 7.14987V12.8498C17.5667 13.7832 17.0667 14.6499 16.2583 15.1249L11.3083 17.9832C10.5 18.4499 9.49999 18.4499 8.68332 17.9832L3.73332 15.1249C2.92499 14.6582 2.42499 13.7915 2.42499 12.8498V7.14987C2.42499 6.21653 2.92499 5.34983 3.73332 4.87483L8.68332 2.0165C9.49165 1.54984 10.4917 1.54984 11.3083 2.0165L16.2583 4.87483C17.0667 5.34983 17.5667 6.2082 17.5667 7.14987Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.99999 9.16651C11.0723 9.16651 11.9417 8.29719 11.9417 7.22483C11.9417 6.15248 11.0723 5.2832 9.99999 5.2832C8.92763 5.2832 8.05832 6.15248 8.05832 7.22483C8.05832 8.29719 8.92763 9.16651 9.99999 9.16651Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.3333 13.8831C13.3333 12.3831 11.8417 11.1665 9.99999 11.1665C8.15832 11.1665 6.66666 12.3831 6.66666 13.8831"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
